import { combineEpics } from 'redux-observable';
import { fetchEligibilityEpic } from 'medication_service_ui';
import { emrEpics } from '@td/practice_management_js';
import rteTestEpic from '../RteTestComponent/epics';

import {
  filterIncentiveCosts,
  fetchProvidersForIncentiveCostRequest,
  createManyIncentivesRequests,
  finishManyIncentivesRequests,
  deleteIncentiveCostRequest,
  toggleProviderInclusionInIncentive
} from '../provider-incentive/provider-incentive-cost/epics';

import providerSurgeIncentiveEpics from '../provider-incentive/provider-surge-incentive/epics';

import consultQueueEpics from '../consult-queue/epics';

import { editPayerEpic, restorePayerVersionEpic } from '../EditPayer/epics';

import {
  fetchExternalGroupRelationsEpic,
  deleteExternalGroupRelationEpic,
  updateExternalGroupRelationEpic,
  createExternalGroupRelationEpic,
  fetchGroupsEpic,
  importExternalGroupRelationEpic
} from '../external_group_relations/epics';


import {
  fetchMultiContractRelationEpic,
  createMultiContractOrgRelationEpic,
  searchBenefitSponsorContractRelationsEpic
} from '../multi_contract_org_relations/epics';

import emrManagerEpics from '../GrantRevokeEmrManagerRole/redux/epics'

export default combineEpics(
  rteTestEpic,
  fetchEligibilityEpic,
  filterIncentiveCosts,
  fetchProvidersForIncentiveCostRequest,
  createManyIncentivesRequests,
  finishManyIncentivesRequests,
  deleteIncentiveCostRequest,
  toggleProviderInclusionInIncentive,
  providerSurgeIncentiveEpics,
  consultQueueEpics,
  editPayerEpic,
  restorePayerVersionEpic,
  fetchExternalGroupRelationsEpic,
  deleteExternalGroupRelationEpic,
  updateExternalGroupRelationEpic,
  createExternalGroupRelationEpic,
  fetchGroupsEpic,
  importExternalGroupRelationEpic,
  emrEpics,
  fetchMultiContractRelationEpic,
  createMultiContractOrgRelationEpic,
  searchBenefitSponsorContractRelationsEpic,
  emrManagerEpics
);
